module.exports = __webpack_public_path__ + "img/p3.55a731a3.jpg";